/* JUSTYOL — homepage drop teaser. Reveals itself only for shoppers who
   unlocked the drop (localStorage jy_drop_unlocked), and runs the countdown to
   the launch. After launch it swaps the countdown for a "live" badge. */
(function () {
  'use strict';
  var root = document.querySelector('[data-jy-drop-teaser]');
  if (!root) return;

  /* gate: unlocked shoppers see it live. Always reveal inside the theme editor
     (design mode) and when force-show is on, so it can be previewed/merchandised. */
  var force = root.getAttribute('data-force') === 'true';
  var design = !!(window.Shopify && window.Shopify.designMode);
  var unlocked = false;
  try { unlocked = localStorage.getItem('jy_drop_unlocked') === '1'; } catch (e) {}
  /* cookie fallback (localStorage blocked) — mirrors the flag set on unlock */
  if (!unlocked) { try { unlocked = /(?:^|;\s*)jy_drop_unlocked=1(?:;|$)/.test(document.cookie); } catch (e) {} }
  if (!unlocked && !force && !design) return; // stays hidden for un-unlocked visitors
  root.hidden = false;

  /* just-unlocked hand-off: after redirecting from the drop landing, scroll this
     section into view and play a highlight animation so it's obvious the offer
     was added. One-shot — the flag is cleared so a normal revisit stays calm. */
  var justUnlocked = false;
  try { justUnlocked = sessionStorage.getItem('jy_drop_reveal') === '1'; } catch (e) {}
  if (justUnlocked) {
    try { sessionStorage.removeItem('jy_drop_reveal'); } catch (e) {}
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    /* wait for layout/fonts to settle before measuring the scroll target */
    setTimeout(function () {
      try {
        root.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'center' });
      } catch (e) {
        try { root.scrollIntoView(); } catch (e2) {}
      }
      if (!reduce) {
        root.classList.add('jydt--reveal');
        setTimeout(function () { root.classList.remove('jydt--reveal'); }, 2600);
      }
    }, 450);
  }

  /* ---- countdown (bare local strings are Morocco wall-clock → pin +01:00) ---- */
  var raw = (root.getAttribute('data-drop-date') || '').trim();
  var dropMs = 0;
  if (raw) {
    if (!/[zZ]|[+-]\d\d:?\d\d$/.test(raw)) raw = raw.replace(' ', 'T') + '+01:00';
    var p = Date.parse(raw);
    if (!isNaN(p)) dropMs = p;
  }

  var cd = root.querySelector('[data-jydt-cd]');
  var live = root.querySelector('[data-jydt-live]');
  var cells = {
    d: root.querySelector('[data-cd="d"]'),
    h: root.querySelector('[data-cd="h"]'),
    m: root.querySelector('[data-cd="m"]'),
    s: root.querySelector('[data-cd="s"]')
  };
  function pad(n) { return n < 10 ? '0' + n : '' + n; }

  var timer = null;
  function tick() {
    if (!dropMs || Date.now() >= dropMs) {
      // launched → drop the timer, show the live badge
      if (cd) cd.hidden = true;
      if (live) live.hidden = false;
      if (timer) { clearInterval(timer); timer = null; }
      return;
    }
    var s = Math.max(0, Math.floor((dropMs - Date.now()) / 1000));
    if (cells.d) cells.d.textContent = pad(Math.floor(s / 86400));
    if (cells.h) cells.h.textContent = pad(Math.floor((s % 86400) / 3600));
    if (cells.m) cells.m.textContent = pad(Math.floor((s % 3600) / 60));
    if (cells.s) cells.s.textContent = pad(s % 60);
  }
  tick();
  if (dropMs && Date.now() < dropMs) timer = setInterval(tick, 1000);
})();
